import React from 'react'
import {useItemVariant} from '@salesforce/retail-react-app/app/components/item-variant'
import {findImageGroupBy} from '@salesforce/retail-react-app/app/utils/image-groups-utils'
import {useAppOrigin} from '~/app/hooks/use-app-origin'

/**
 * In the context of a cart product item variant, this component renders the item's
 * main image.
 *
 * @todo = This component will render a `SALE` badge when the qualifier is available
 * on the custom property `c_isSale`. This will need to be expanded upon to handle
 * different badge/qualifiers and property names.
 */
const ProductImage = () => {
    const variant = useItemVariant()
    const appOrigin = useAppOrigin()

    // We find the 'small' images in the variant's image groups based on variationValues and pick the first one
    const image = findImageGroupBy(variant?.imageGroups, {
        viewType: 'large',
        selectedVariationAttributes: variant?.variationValues
    })?.images?.[0]

    // disBaseLink points to demandware.net which is 403 externally.
    // Extract the pathname and proxy through our domain instead.
    let imageSrc = image?.link
    if (image?.disBaseLink) {
        try {
            const pathname = new URL(image.disBaseLink).pathname
            imageSrc = `${appOrigin}${pathname}?sw=90`
        } catch {
            // Invalid URL, fall back to image.link
        }
    }

    return <img className="w-full h-auto aspect-square" src={imageSrc} alt={image?.alt} />
}

export default ProductImage
